import { notificationsClient } from 'clients/NotificationsClient/NotificationsClient';
import { crawlerClient } from 'clients/CrawlerClient/CrawlerClient';
import { CandidateDto } from 'clients/NotificationsClient/NotificationsClient.types';
import { UserResponse } from 'clients/UserClient/types';
import { IndeedConversation } from './indeed/indeed.types';
import { MessageReceivedPlatform } from './platform.types';

export const fallbackSaveReceivedMessages = async ({
  currentUser,
  messages,
  candidate,
  platform,
}: {
  currentUser: UserResponse | undefined;
  messages: any[];
  candidate: CandidateDto;
  platform: MessageReceivedPlatform;
}) => {
  if (!currentUser) return;

  try {
    if (platform === MessageReceivedPlatform.INDEED && candidate) {
      return await crawlerClient.saveNewIndeedMessage({
        messages: messages as IndeedConversation[],
        credentialEmail: currentUser.email,
        candidate: candidate,
      });
    } else {
      throw new Error('No crawler route available, using fallback');
    }
  } catch (error: any) {
    try {
      await notificationsClient.fallbackSaveMessages({
        candidateId: candidate.source_id,
        credentialUsername: currentUser.email,
        platform,
        messages,
        candidateName: candidate.candidate_name,
      });
    } catch (fallbackError) {
      console.error('Fallback save messages also failed:', fallbackError);
      throw fallbackError;
    }
  }
};
